import React, { useState, useEffect} from 'react';
import './avatar.css'
import SVG from '../../svg/Svg';

const DEFAULT_AVATAR = '/avatars/default.jpg';

const HeaderImage = ({ imageUrl, menuUrl, Click }) => {
  const [isImageError, setIsImageError] = useState(false);
  const [src, setSrc] = useState(imageUrl);

  useEffect(() => {
    // `R.8` (`ТЕСТ-Н110`): при смене URL — одна попытка, без повторов.
    setSrc(imageUrl);
    setIsImageError(false);
  }, [imageUrl]);

  return (
    <div
      className="header-image-container"
      onClick={Click}
    >
      {isImageError ? (
        <div>{SVG['defaultAva']}</div>
      ) : (
        <img
          src={src}
          alt="Header_Image"
          className="header-image"
          onLoad={() => setIsImageError(false)}
          onError={() => {
            // Ошибка картинки → дефолтный аватар. Если и он не открылся —
            // заглушка; второго запроса по таймеру нет.
            if (src !== DEFAULT_AVATAR) {
              setSrc(DEFAULT_AVATAR);
            } else {
              setIsImageError(true);
            }
          }}
        />
      )}
      <div
        src={menuUrl}
        alt="Menu_Image"
        className="menu-image"
      >
        {SVG['mark']}
      </div>
    </div>
  );
};

export default HeaderImage;
